import {
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
  Button,
} from "@mui/material";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import SearchIcon from "@mui/icons-material/Search";

const tdLabelSx = {
  width: 300,
  bgcolor: "#f3f3f3",
  borderRight: "1px solid #e0e0e0",
  color: "#333",
  fontWeight: 600,
  verticalAlign: "top",
};

const tdFieldSx = { p: 1.5 };

const noteSx = {
  color: "#666",
  fontSize: 12,
  lineHeight: 1.25,
};

const EnterpriseForm = ({
  empresa,
  setEmpresa,
  handleChange,
  handleCheck,
  handleFile,
  fileLabel,
  openPreview,
  submit,
  logoRef,
}) => {
  return (
    <Box component="form" onSubmit={submit}>
      <Box sx={{ bgcolor: "#f3f3f3", borderBottom: "1px solid #e0e0e0", p: 1.5 }}>
        <Typography sx={{ fontWeight: 700, color: "#333" }}>
          Configuraciones de la Empresa
        </Typography>
      </Box>

      <Table sx={{ "& td, & th": { borderBottom: "1px solid #eaeaea" } }}>
        <TableBody>
          <TableRow>
            <TableCell sx={tdLabelSx}>Ruc:</TableCell>
            <TableCell sx={tdFieldSx}>
              <TextField fullWidth name="ruc" value={empresa.ruc} onChange={handleChange} />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Razón social:</TableCell>
            <TableCell sx={tdFieldSx}>
              <TextField
                fullWidth
                name="razon_social"
                value={empresa.razon_social}
                onChange={handleChange}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Nombre comercial:</TableCell>
            <TableCell sx={tdFieldSx}>
              <TextField
                fullWidth
                name="nombre_comercial"
                value={empresa.nombre_comercial}
                onChange={handleChange}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>
              Número de Establecimiento:
              <Box sx={noteSx}>(Formato válido: 001, 002, 003, etc.)</Box>
            </TableCell>
            <TableCell sx={tdFieldSx}>
              <TextField
                fullWidth
                name="numero_establecimiento"
                value={empresa.numero_establecimiento}
                onChange={handleChange}
                inputProps={{
                    maxLength: 3,
                    inputMode: "numeric",
                    pattern: "\\d*",
                }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Obligado a llevar contabilidad:</TableCell>
            <TableCell sx={tdFieldSx}>
              <FormControl fullWidth>
                <InputLabel>Selecciona</InputLabel>
                <Select
                  label="Selecciona"
                  name="obligado_contabilidad"
                  value={empresa.obligado_contabilidad || "NO"}
                  onChange={handleChange}
                >
                  <MenuItem value="NO">NO</MenuItem>
                  <MenuItem value="SI">SI</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Contribuyente especial:</TableCell>
            <TableCell sx={tdFieldSx}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!empresa.contribuyente_especial}
                    onChange={handleCheck}
                    name="contribuyente_especial"
                  />
                }
                label=""
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Gran Contribuyente:</TableCell>
            <TableCell sx={tdFieldSx}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!empresa.gran_contribuyente}
                    onChange={handleCheck}
                    name="gran_contribuyente"
                  />
                }
                label=""
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Exportador:</TableCell>
            <TableCell sx={tdFieldSx}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!empresa.exportador}
                    onChange={handleCheck}
                    name="exportador"
                  />
                }
                label=""
              />

              {empresa.exportador && (
                <RadioGroup
                  row
                  name="exportador_tipo"
                  value={empresa.exportador_tipo || "NO_HABITUAL"}
                  onChange={handleChange}
                  sx={{ ml: 2 }}
                >
                  <FormControlLabel value="NO_HABITUAL" control={<Radio />} label="No habitual" />
                  <FormControlLabel value="HABITUAL" control={<Radio />} label="Habitual" />
                </RadioGroup>
              )}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Contribuyente Régimen RIMPE:</TableCell>
            <TableCell sx={tdFieldSx}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!empresa.contribuyente_rimpe}
                    onChange={handleCheck}
                    name="contribuyente_rimpe"
                  />
                }
                label=""
              />

              {empresa.contribuyente_rimpe && (
                <FormControl sx={{ ml: 2, minWidth: 340 }}>
                  <InputLabel>Seleccione</InputLabel>
                  <Select
                    label="Seleccione"
                    name="rimpe_tipo"
                    value={empresa.rimpe_tipo || ""}
                    onChange={handleChange}
                  >
                    <MenuItem value="EMPRENDEDOR">Contribuyente Régimen RIMPE</MenuItem>
                    <MenuItem value="NEGOCIO_POPULAR">
                      Contribuyente Negocio Popular - Régimen RIMPE
                    </MenuItem>
                  </Select>
                </FormControl>
              )}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Contribuyente Régimen GENERAL:</TableCell>
            <TableCell sx={tdFieldSx}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!empresa.regimen_general}
                    onChange={handleCheck}
                    name="regimen_general"
                  />
                }
                label=""
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Agente de retención:</TableCell>
            <TableCell sx={tdFieldSx}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!empresa.agente_retencion}
                    onChange={handleCheck}
                    name="agente_retencion"
                  />
                }
                label=""
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Ciudad:</TableCell>
            <TableCell sx={tdFieldSx}>
              <TextField fullWidth name="ciudad" value={empresa.ciudad} onChange={handleChange} />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Teléfonos:</TableCell>
            <TableCell sx={tdFieldSx}>
              <TextField
                fullWidth
                name="telefonos"
                value={empresa.telefonos}
                onChange={handleChange}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Dirección:</TableCell>
            <TableCell sx={tdFieldSx}>
              <TextField
                fullWidth
                multiline
                minRows={1}
                name="direccion"
                value={empresa.direccion}
                onChange={handleChange}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Email Notificación:</TableCell>
            <TableCell sx={tdFieldSx}>
              <TextField
                fullWidth
                type="email"
                name="email_notificacion"
                value={empresa.email_notificacion}
                onChange={handleChange}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>
              Logo de la Empresa:
              <Box sx={noteSx}>(Ancho y alto máximo: 500x300 px)</Box>
              <Box sx={noteSx}>Formato permitido: jpg, jpeg, png.</Box>
            </TableCell>
            <TableCell sx={tdFieldSx}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <Button
                  variant="contained"
                  onClick={() => logoRef.current?.click()}
                  startIcon={<FolderOpenIcon />}
                  sx={{ textTransform: "none", bgcolor: "#1976d2" }}
                >
                  Seleccionar
                </Button>

                <input
                  ref={logoRef}
                  type="file"
                  name="logo_empresa"
                  accept="image/png,image/jpeg"
                  hidden
                  onChange={handleFile}
                />

                <Box sx={{ color: "#777" }}>{fileLabel(empresa.logo_empresa)}</Box>

                <Box sx={{ flexGrow: 1 }} />

                {!!empresa.logo_empresa && (
                  <Button
                    variant="contained"
                    onClick={() => openPreview(empresa.logo_empresa)}
                    startIcon={<SearchIcon sx={{ color: "#fff" }} />}
                    sx={{
                      textTransform: "none",
                      bgcolor: "#0AA1FF",
                      color: "#fff",
                      "&:hover": { bgcolor: "#0a8be6" },
                    }}
                  >
                    Ver
                  </Button>
                )}
              </Box>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Box sx={{ p: 2, textAlign: "right", borderTop: "1px solid #eaeaea" }}>
        <Button
          type="submit"
          variant="contained"
          sx={{ textTransform: "none", bgcolor: "#1565C0", "&:hover": { bgcolor: "#0D47A1" } }}
        >
          Guardar Cambios
        </Button>
      </Box>
    </Box>
  );
};

export default EnterpriseForm;
